import { useCallback } from 'react'

// Custom hook for managing sound effects - 2024-12-19
export function useSoundEffects() {
  // Play hover sound effect
  const playHoverSound = useCallback(() => {
    const audio = new Audio('/media/sfx/hover.mp3')
    audio.volume = 0.3 // Lower volume for frequent hover sounds
    audio.play().catch((error) => {
      console.log('Hover sound failed:', error)
    })
  }, [])

  // Play menu open sound effect
  const playMenuOpenSound = useCallback(() => {
    const audio = new Audio('/media/sfx/menu-open.mp3')
    audio.volume = 0.5
    audio.play().catch((error) => {
      console.log('Menu open sound failed:', error)
    })
  }, [])

  // Play menu close sound effect
  const playMenuCloseSound = useCallback(() => {
    const audio = new Audio('/media/sfx/menu-close.mp3')
    audio.volume = 0.5
    audio.play().catch((error) => {
      console.log('Menu close sound failed:', error)
    })
  }, [])

  return {
    playHoverSound,
    playMenuOpenSound,
    playMenuCloseSound
  }
}
